import { render } from "./ForDevelopers.vue?vue&type=template&id=31e57805"
import script from "./ForDevelopers.vue?vue&type=script&lang=js"
export * from "./ForDevelopers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__